import commonAPI from './common.js';
export default {
    // 负面舆情详情页---权限
    negativeAuth() {
        let authList = [];
        const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
        const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU0601"); //涉旅负面舆情---这个位置有点小争议。
        // console.log("-----涉旅负面舆情权限:", notifyobj);
        if (notifyobj) {
            const childList = notifyobj.operationType;
            if (childList && childList.length > 0) {
                if (childList && childList.length > 0) {
                    for (let j = 0; j < childList.length; j++) {
                        if (childList[j].value === "OPERATION01") {
                            // this.addAuth = "OPERATION01"; //新增
                            let obj = { addAuth: "OPERATION01" }
                            authList.push(obj);
                        }
                        if (childList[j].value === "OPERATION02") {
                            // this.updateAuth = "OPERATION02"; //编辑
                            let obj = { updateAuth: "OPERATION02" };
                            authList.push(obj);
                        }
                        if (childList[j].value === "OPERATION03") {
                            // this.deleteAuth = "OPERATION03"; //删除
                            let obj = { deleteAuth: "OPERATION03" }
                            authList.push(obj);
                        }
                        if (childList[j].value === "OPERATION06") {
                            this.userAuthoirese = "OPERATION06";
                            let obj = { userAuthoirese: "OPERATION06" }
                            authList.push(obj);
                        }
                    }
                    return authList;
                }
            }
        }
    },
    getNegativeAuth(key) {
        const list = this.negativeAuth();
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                for (let mKey in list[i]) {
                    if (key === mKey) {
                        return list[i][mKey]
                    }
                }
            }
        } else {
            console.log('暂无负面舆情相关权限');
        }
    },
    tranAcidentAuthc() {
        // 涉旅安全事故 权限
        let authList = [];
        const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
        const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU0401"); //涉旅安全事故
        console.log("-----涉旅安全事故权限:", notifyobj);
        if (notifyobj) {
            const childList = notifyobj.operationType;
            if (childList && childList.length > 0) {
                for (let j = 0; j < childList.length; j++) {
                    if (childList[j].value === "OPERATION01") {
                        // this.addAuth = "OPERATION01"; //新增
                        let obj = { addAuth: 'OPERATION01' }
                        authList.push(obj);
                    }
                    if (childList[j].value === "OPERATION02") {
                        // this.updateAuth = "OPERATION02"; //编辑
                        let obj = { updateAuth: 'OPERATION02' }
                        authList.push(obj);
                    }
                    if (childList[j].value === "OPERATION03") {
                        // this.deleteAuth = "OPERATION03"; //删除
                        let obj = { deleteAuth: 'OPERATION03' }
                        authList.push(obj);
                    }
                    if (childList[j].value === "OPERATION06") {
                        // this.userAuthoirese = "OPERATION06";
                        let obj = { userAuthoirese: 'OPERATION06' }
                        authList.push(obj);
                    }
                }
                return authList
            }
        }
    },
    getTranAcidentAuth(key) {
        const list = this.tranAcidentAuthc();
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                for (let mKey in list[i]) {
                    if (key === mKey) {
                        return list[i][mKey]
                    }
                }
            }
        } else {
            console.log('暂无涉旅安全事故相关权限');
        }
    },
    notificationAuthc() {
        // 受到上级批评
        let authList = [];
        const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
        const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU05"); //受到通报批评、约谈、问责等情况
        // 先 判断大项。再判断 小项的 按钮权限
        // console.log("-----受到通报批评大项的值:", notifyobj);
        if (notifyobj && notifyobj.children) {
            const childList = notifyobj.children;
            // this.accidentListAuth = "";
            // this.meetListAuth = "";
            // this.abarbeitungListAuth = "";
            for (let i = 0; i < childList.length; i++) {
                if (childList[i].assessType === "E1") {
                    // this.accidentListAuth = "E1";
                    let obj = { accidentListAuth: 'E1' }
                    authList.push(obj);
                }
                if (childList[i].assessType === "E2") {
                    // this.meetListAuth = "E2";
                    let obj = { meetListAuth: 'E2' }
                    authList.push(obj);
                }
                if (childList[i].assessType === "E3") {
                    // this.abarbeitungListAuth = "E3";
                    let obj = { abarbeitungListAuth: 'E3' }
                    authList.push(obj);
                }
            }
            let temValue = "";
            if (this.accidentListAuth === "E1") {
                temValue = "MENU0501";
            } else if (this.meetListAuth === "E2") {
                temValue = "MENU0502";
            } else if (this.abarbeitungListAuth === "E3") {
                temValue = "MENU0503";
            }

            const childObj = commonAPI.getChildAuthListToChild(notifyobj, temValue);
            if (childObj && childObj.length > 0) {
                // this.userAuthoirese = "";
                // this.addBtn = "";
                // this.updateAuth = "";
                // this.deleteAuth = "";
                for (let i = 0; i < childObj.length; i++) {
                    if (childObj[i].value === "OPERATION06") {
                        //审核权限
                        // this.userAuthoirese = "OPERATION06";
                        let obj = { userAuthoirese: 'OPERATION06' }
                        authList.push(obj);
                    }
                    if (childObj[i].value === "OPERATION01") {
                        // 新增
                        // this.addAuth = "OPERATION01";
                        let obj = { addAuth: 'OPERATION01' }
                        authList.push(obj);
                    }
                    if (childObj[i].value === "OPERATION02") {
                        //编辑
                        // this.updateAuth = "OPERATION02";
                        let obj = { updateAuth: 'OPERATION02' }
                        authList.push(obj);
                    }
                    if (childObj[i].value === "OPERATION03") {
                        //删除
                        // this.deleteAuth = "OPERATION03";
                        let obj = { deleteAuth: 'OPERATION03' }
                        authList.push(obj);
                    }
                }
                return authList;
            }
        }
    },
    getnotificationAuth(key) {
        const list = this.notificationAuthc();
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                for (let mKey in list[i]) {
                    if (key === mKey) {
                        return list[i][mKey]
                    }
                }
            }
        } else {
            console.log('暂无受到通报批评相关权限');
        }
    },
    creditAuthc() {
        // 涉旅企业诚信评价
        let authList = [];
        const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
        const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU03"); //涉旅企业诚信
        if (notifyobj) {
            const childList = notifyobj.children;
            if (childList && childList.length > 0) {
                // 拿任意 类型数据的按钮权限集合。
                // this.addAuth = "";
                // this.updateAuth = "";
                // this.deleteAuth = "";
                // this.userAuthoirese = "";
                const btnList = childList[0].operationType;
                console.log("------按钮权限;", btnList);
                if (btnList) {
                    for (let j = 0; j < btnList.length; j++) {
                        if (btnList[j].value === "OPERATION01") {
                            // this.addAuth = "OPERATION01"; //新增
                            let obj = { addAuth: 'OPERATION01'}
                            authList.push(obj);
                        }
                        if (btnList[j].value === "OPERATION02") {
                            // this.updateAuth = "OPERATION02"; //编辑
                            let obj = { updateAuth: 'OPERATION02'}
                            authList.push(obj);
                        }
                        if (btnList[j].value === "OPERATION03") {
                            // this.deleteAuth = "OPERATION03"; //删除
                            let obj = { deleteAuth: 'OPERATION03'}
                            authList.push(obj);
                        }
                        if (btnList[j].value === "OPERATION06") {
                            // this.userAuthoirese = "OPERATION06";
                            let obj = { userAuthoirese: 'OPERATION06'}
                            authList.push(obj);
                        }
                    }
                }
            }
        }
    },
    getcreditnAuth(key) {
        const list = this.creditAuthc();
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                for (let mKey in list[i]) {
                    if (key === mKey) {
                        return list[i][mKey]
                    }
                }
            }
        } else {
            console.log('暂无涉旅企业诚信相关权限');
        }
    },
}